import React, { useState } from 'react';
import Cropper from "react-easy-crop";

const styles = {
    sectionContainer: "mt-6 flex flex-col",
    sectionHeader: "text-lg md:text-xl 2xl:text-2xl",
    label: "block text-md md:text-lg text-gray-700 font-proximanova",
    sublabel: " mt-4  block text-md md:text-md text-gray-700 font-proximanova",
    uploadContainer: "mt-2 h-48 border-2 border-dotted border-boxBorder rounded flex flex-col items-center justify-center bg-white",
    browseButton: "mt-3 cursor-pointer border text-black font-semibold px-3 py-2 rounded",
    imageContainer: "mt-4 h-48 border rounded p-4 flex flex-row justify-between",
    imagePreview: "w-[160px] h-[160px] relative",
    flexColumn: "flex flex-col",
    flexRow: "flex flex-row justify-between",
    buttonsContainer: "flex flex-col sm:flex-row justify-center items-end gap-4",
    buttonEnabled: "w-40 sm:w-fit h-fit text-lg xl:text-xl font-semibold px-4 xl:px-5 py-2 xl:py-3 rounded-full text-white bg-link hover:text-integrationRequestTextHover hover:bg-charmHover",
    buttonDisabled: "w-40 sm:w-fit h-fit text-lg xl:text-xl font-semibold px-4 xl:px-5 py-2 xl:py-3 rounded-full bg-neutral text-white cursor-not-allowed",
    sortableImageContainer: "mt-4 border rounded",
    youtubeInput: "p-2 border border-gray-300 rounded flex-grow",
    removeButton: "ml-2 bg-red text-white px-2 py-1 rounded",
    addLinkButton: "mt-2 text-white text-lg xl:text-xl font-semibold px-4 xl:px-5 py-2 xl:py-3 bg-link hover:text-integrationRequestTextHover hover:bg-charmHover w-fit rounded-full",
    errorMessage: "text-red-500",
};

const close_button_svg = (
    <>
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            className="bi bi-x-lg"
            viewBox="0 0 16 16"
        >
            <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
        </svg>
        <span className="ml-2">Remove</span>
    </>
)

const dataURLtoFile = (dataURL, filename) => {
    const arr = dataURL.split(",");
    const mime = arr[0].match(/:(.*?);/)[1]; // Extract MIME type
    const bstr = atob(arr[1]); // Decode base64
    let n = bstr.length;
    const u8arr = new Uint8Array(n);

    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, { type: mime });
};


const TertiaryDetails = ({
    logo,
    banner,
    imageLinks,
    videoLinks,
    handleLogoUpload,
    handleBannerUpload,
    handleImageUpload,
    removeLogo,
    removeBanner,
    handleRemoveImage,
    handleVideoLinkChange,
    handleDeleteVideoLink,
    handleAddVideoLink,
    extractVideoId,
    lastVideoLinkRef,
    imagesUploading
}) => {

    // const [logo, setLogo] = useState(null); // Final cropped logo
    const [cropImage, setCropImage] = useState(null); // Image for cropping
    const [cropImage_BANNER, setCropImage_BANNER] = useState(null); // Image for croppin
    const [cropImage_IMAGE, setCropImage_IMAGE] = useState(null); // Image for croppin
    const [crop, setCrop] = useState({ x: 0, y: 0 });
    const [zoom, setZoom] = useState(1);
    const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);

    const onCropComplete = (_, croppedAreaPixels) => {
        setCroppedAreaPixels(croppedAreaPixels);
    };

    // Save the cropped area as the final image - FOR LOGO
    const showCroppedImage = async () => {
        const croppedImage = await getCroppedImage(cropImage, croppedAreaPixels);
        // Convert the base64 Data URL to a File object
        const croppedFile = dataURLtoFile(croppedImage, "cropped-logo.jpg");
        // Call the upload handler with the File object
        handleLogoUpload(
            { target: { files: [croppedFile] } }
        );
        setCropImage(null); // Exit crop mode
    };

    // Save the cropped area as the final image - FOR LOGO
    const showCroppedImage_BANNER = async () => {
        const croppedImage = await getCroppedImage(cropImage_BANNER, croppedAreaPixels);
        // Convert the base64 Data URL to a File object
        const croppedFile = dataURLtoFile(croppedImage, "cropped-logo.jpg");
        // Call the upload handler with the File object
        handleBannerUpload(
            { target: { files: [croppedFile] } }
        );
        setCropImage_BANNER(null); // Exit crop mode
    };
    // Save the cropped area as the final image - FOR LOGO
    const showCroppedImage_IMAGE = async () => {
        const croppedImage = await getCroppedImage(cropImage_IMAGE, croppedAreaPixels);
        // Convert the base64 Data URL to a File object
        const croppedFile = dataURLtoFile(croppedImage, "cropped-logo.jpg");
        // Call the upload handler with the File object
        handleImageUpload(
            { target: { files: [croppedFile] } }
        );
        setCropImage_IMAGE(null); // Exit crop mode
    };

    // Handle file upload
    const crop_handleLogoUpload = (e) => {
        const file = e.target.files[0] || e.dataTransfer?.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onload = () => setCropImage(reader.result);
            reader.readAsDataURL(file);
        }
    };

    // Handle file upload
    const crop_handleLogoUpload_BANNER = (e) => {
        const file = e.target.files[0] || e.dataTransfer?.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onload = () => setCropImage_BANNER(reader.result);
            reader.readAsDataURL(file);
        }
    };


    // Handle file upload
    const crop_handleLogoUpload_IMAGE = (e) => {
        const file = e.target.files[0] || e.dataTransfer?.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onload = () => setCropImage_IMAGE(reader.result);
            reader.readAsDataURL(file);
        }
    };

    // Utility function to get cropped image
    const getCroppedImage = (imageSrc, cropArea) => {
        return new Promise((resolve) => {
            const image = new Image();
            image.src = imageSrc;
            image.onload = () => {
                const canvas = document.createElement("canvas");
                const ctx = canvas.getContext("2d");

                canvas.width = cropArea.width;
                canvas.height = cropArea.height;

                ctx.fillStyle = "white";
                ctx.fillRect(0, 0, canvas.width, canvas.height);

                ctx.drawImage(
                    image,
                    cropArea.x,
                    cropArea.y,
                    cropArea.width,
                    cropArea.height,
                    0,
                    0,
                    cropArea.width,
                    cropArea.height
                );
                resolve(canvas.toDataURL("image/jpeg"));
            };
        });
    };

    return (
        <div>
            <div className="mt-[16px] w-full flex flex-col">
                {/* Logo Section */}
                <div className="logo-div">
                    <label className="w-full text-left font-proximanova font-[600] text-[18px] text-[#404040] mb-1" style={{ lineHeight: '1.35' }}>
                        Listing Logo
                        <span style={{ color: '#9a016a' }}> *</span> </label>
                    <label className="font-proximanova font-[400] text-[16px] text-[#404040]" style={{ lineHeight: '1.35' }}>
                        Recommended aspect ratio: 1:1 | Supported formats: JPG, JPEG, PNG, WEBP | Max logo file size: 5MB
                    </label>

                    {/* Cropper Modal */}
                    {cropImage ? (
                        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-75 z-50">
                            <div className="bg-white rounded-md p-4 w-[500px] h-[500px] relative flex flex-col">
                                <div className="relative flex-1">
                                    <Cropper
                                        image={cropImage}
                                        crop={crop}
                                        zoom={zoom}
                                        aspect={1} // Forces square cropping
                                        onCropChange={setCrop}
                                        onZoomChange={setZoom}
                                        onCropComplete={onCropComplete}

                                    />
                                </div>
                                <div className="flex justify-between mt-4">
                                    <button className="text-white text-[18px] font-proximanova px-[24px] py-[3px] bg-[#fd5764] hover:text-integrationRequestTextHover hover:bg-charmHover w-fit rounded-full"
                                        onClick={() => setCropImage(null)}
                                    >
                                        Cancel
                                    </button>
                                    <button className="text-white text-[18px] font-proximanova px-[24px] py-[3px] bg-[#76da24] hover:text-integrationRequestTextHover hover:bg-charmHover w-fit rounded-full"
                                        onClick={showCroppedImage}
                                    >
                                        Save
                                    </button>
                                </div>
                            </div>
                        </div>

                    ) : logo ? (
                        <div className="mt-4 h-48 border p-4 flex justify-between">
                            <div className="w-[140px] h-[140px] relative">
                                <img
                                    src={logo}
                                    alt="Uploaded Logo"
                                    className="w-full h-full object-cover"
                                />
                            </div>
                            <button
                                className=""
                                onClick={removeLogo}
                            >
                                <div className="flex items-center close-button-hover text-red">
                                    {close_button_svg}
                                </div>
                            </button>
                        </div>
                    ) : (
                        <div
                            className="mt-2 h-48 border-2 border-dotted border-boxBorder rounded flex flex-col items-center justify-center bg-white"
                        >
                            <input
                                type="file"
                                accept=".jpg,.jpeg,.png,.webp"
                                className="hidden"
                                id="logo-upload"
                                onChange={crop_handleLogoUpload}
                            />
                            <label
                                htmlFor="logo-upload"
                                className="cursor-pointer border px-3 py-2 rounded text-sm font-semibold text-gray-600"
                            >
                                Browse File
                            </label>
                        </div>
                    )}
                </div>
                {/* Banner Section */}
                <div className="mt-[16px]">
                    <label className="w-full text-left font-proximanova font-[600] text-[18px] text-[#404040] mb-1" style={{ lineHeight: '1.35' }}>
                        Listing Banner
                    </label>
                    <label className="font-proximanova font-[400] text-[16px] text-[#404040]" style={{ lineHeight: '1.35' }}>
                        Recommended aspect ratio: 5:1 | Supported formats: JPG, JPEG, PNG, WEBP | Max banner file size: 5MB
                    </label>

                    {/* Cropper Modal */}
                    {cropImage_BANNER ? (
                        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-75 z-50">
                            <div className="bg-white rounded-md p-4 w-[800px] relative flex flex-col">
                                <div className="relative w-full aspect-[2.63]">
                                    <Cropper
                                        image={cropImage_BANNER}
                                        crop={crop}
                                        zoom={zoom}
                                        aspect={5} // fb banner
                                        onCropChange={setCrop}
                                        onZoomChange={setZoom}
                                        onCropComplete={onCropComplete}
                                    />
                                </div>
                                <div className="flex justify-between mt-4">
                                    <button className="text-white text-[18px] font-proximanova px-[24px] py-[3px] bg-[#fd5764] hover:text-integrationRequestTextHover hover:bg-charmHover w-fit rounded-full"
                                        onClick={() => setCropImage_BANNER(null)}
                                    >
                                        Cancel
                                    </button>
                                    <button className="text-white text-[18px] font-proximanova px-[24px] py-[3px] bg-[#76da24] hover:text-integrationRequestTextHover hover:bg-charmHover w-fit rounded-full"
                                        onClick={showCroppedImage_BANNER}
                                    >
                                        Save
                                    </button>
                                </div>
                            </div>
                        </div>

                    ) :
                        !banner ? (
                            <div
                                className="mt-2 h-48 border-2 border-dotted border-boxBorder rounded flex flex-col items-center justify-center bg-white"
                                onDrop={handleBannerUpload}
                                onDragOver={(e) => e.preventDefault()}
                            >
                                <input
                                    type="file"
                                    accept=".jpg,.jpeg,.png,.webp"
                                    className="hidden"
                                    id="banner-upload"
                                    onChange={crop_handleLogoUpload_BANNER}
                                />
                                <label htmlFor="banner-upload" className="mt-3 cursor-pointer border text-black font-semibold px-3 py-2 rounded">
                                    Browse file
                                </label>
                            </div>
                        ) : (
                            <div className="mt-4 h-48 border rounded p-4 flex flex-row justify-between">
                                <div className="flex flex-col flex-1 justify-start">
                                    <div className="w-full h-full">
                                        <img
                                            src={banner}
                                            alt="Uploaded Banner"
                                            className="w-full h-full object-contain object-left"
                                        />
                                    </div>
                                </div>
                                <div className="flex flex-col sm:flex-row justify-center">
                                    <button className={styles.closeButton} onClick={removeBanner}>
                                        <div className="flex items-center close-button-hover text-red">
                                            {close_button_svg}
                                        </div>
                                    </button>
                                </div>
                            </div>
                        )}
                </div>

                {/* Product Images Section */}
                <div className="mt-[16px]">
                    <label className="w-full text-left font-proximanova font-[600] text-[18px] text-[#404040] mb-1" style={{ lineHeight: '1.35' }}>
                        Product Images
                    </label>
                    <label className="font-proximanova font-[400] text-[16px] text-[#404040]" style={{ lineHeight: '1.35' }}>
                        Recommended aspect ratio: 16:9 | Supported formats: JPG, JPEG, PNG, WEBP | Max image file size: 5MB | Max 5 images
                    </label>

                    {!imageLinks.length ? (
                        <div
                            className="mt-2 h-48 border-2 border-dotted border-boxBorder rounded flex flex-col items-center justify-center bg-white"
                            onDragOver={(e) => e.preventDefault()}
                        >
                            <input
                                type="file"
                                accept=".jpg,.jpeg,.png,.webp"
                                className="hidden"
                                id="image-upload"
                                onChange={handleImageUpload}
                            />
                            <label htmlFor="image-upload" className="mt-3 cursor-pointer border text-black font-semibold px-3 py-2 rounded">
                                Browse file
                            </label>
                        </div>
                    ) : (
                        <div className="mt-4 border rounded p-4">
                            <div className="flex flex-row gap-4 overflow-x-auto">
                                {imageLinks.map((image, index) => (
                                    <div key={index} className="flex flex-col items-center">
                                        <div className="w-[160px] h-[160px] relative">
                                            <img src={image} alt={`Uploaded Image ${index}`} className="w-full h-full object-cover" />
                                        </div>
                                        <div className="flex flex-col justify-center items-center gap-2 mt-2">
                                            <button className={styles.closeButton} onClick={() => handleRemoveImage(index)}>
                                                <div className="flex items-center close-button-hover text-red">
                                                    {close_button_svg}
                                                </div>
                                            </button>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            {imageLinks.length < 5 && <div className="mt-4 flex justify-center">
                                <input
                                    type="file"
                                    accept=".jpg,.jpeg,.png,.webp"
                                    className="hidden"
                                    id="image-add-more"
                                    onChange={handleImageUpload} // This should be the same handler that processes new image uploads
                                />
                                <label htmlFor="image-add-more" className="cursor-pointer border px-4 py-2 rounded text-black font-semibold bg-gray-200 hover:bg-gray-300">
                                    {imagesUploading ? (
                                        <span className="d-flex align-items-center">
                                            <div className="spinner-border spinner-border-sm text-dark mr-2" role="status" aria-hidden="true"></div>
                                            Uploading...
                                        </span>
                                    ) : (
                                        "Add More"
                                    )}
                                </label>

                            </div>}

                        </div>
                    )}
                </div>
            </div>


            <div className="mt-[16px] w-full flex flex-col">
                <label className="w-full text-left font-proximanova font-[600] text-[18px] text-[#404040] mb-1" style={{ lineHeight: '1.35' }}>
                    Videos
                </label>
                <label className="font-proximanova font-[400] text-[16px] text-[#404040]" style={{ lineHeight: '1.35' }}>
                    Please provide any YouTube video links
                </label>
                {videoLinks.map((link, i) => (
                    <div key={i} className="mt-[8px] flex flex-col" ref={i === videoLinks.length - 1 ? lastVideoLinkRef : null}>
                        <div className="flex items-center">
                            <input
                                type="text"
                                value={link}
                                onChange={(e) => handleVideoLinkChange(i, e.target.value)}
                                placeholder="YouTube Link"
                                className="p-2 border border-gray-300 rounded flex-grow"
                            />
                            <button
                                type="button"
                                onClick={() => handleDeleteVideoLink(i)}
                                className="ml-2 bg-red text-white px-2 py-1 rounded"
                            >
                                X
                            </button>
                        </div>
                        {link && (
                            <div className="mt-2">
                                {extractVideoId(link) ? (
                                    <iframe
                                        width="255"
                                        height="150"
                                        src={`https://www.youtube.com/embed/${extractVideoId(link)}`}
                                        frameBorder="0"
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                        allowFullScreen
                                    ></iframe>
                                ) : (
                                    <p className="text-red-500">Error: Invalid YouTube link</p>
                                )}
                            </div>
                        )}
                    </div>
                ))}
                <button
                    type="button"
                    onClick={handleAddVideoLink}
                    className="mt-[16px] w-full sm:w-fit text-white bg-link hover:text-integrationRequestTextHover hover:bg-charmHover rounded-full text-[18px] font-proximanova px-8 py-2 1.5xl:px-10 1.5xl:py-4"
                >
                    Add Link
                </button>
            </div>
        </div>
    );
};

export default TertiaryDetails;
